import React from 'react';
import { Route } from 'react-router';

var ES6Promise = require('es6-promise');
ES6Promise.polyfill();
var axios = require('axios');

class KeepAlive extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: null,
      detail: null
    };
  }

  componentDidMount() {
    this.callKeepAlive();
  }

  callKeepAlive() {
    axios
      .get(process.env.REACT_APP_BACKEND_URL + 'actuator/keepalive')
      .then(response => {
        this.setState({
          page: 'keepAlive',
          detail: response.data.status
        });
      })
      .catch(err => {
        this.setState({
          page: 'error',
          detail: err.response.data.responseParameter
        });
      });
  }

  render() {
    if (this.state.page === 'error') {
      return (
        <Route status={404} />
      );
    }

    if (this.state.page === 'keepAlive') {
      return <div> {'I\'m Alive'} </div>;
    }

    return <div />;
  }
}

export default KeepAlive;
